module.exports = __webpack_public_path__ + "staticVue/img/game_list02.140e238b.jpg";